import React from 'react';
import { ChevronRight, Home, ArrowLeft } from 'lucide-react';

/**
 * Breadcrumb Navigation Component
 * Shows: Hub > Module > Screen
 * Clicking any crumb navigates back to that level
 */
const Breadcrumb = ({ 
  items = [], 
  onNavigate, 
  onBack,
  canGoBack = false,
  theme = 'dark' 
}) => {
  const isDark = theme === 'dark';

  if (!items || items.length === 0) return null;

  return (
    <div className={`flex items-center gap-1.5 text-xs ${isDark ? 'text-slate-400' : 'text-slate-600'}`}>
      {/* Back Button */}
      {canGoBack && onBack && (
        <button
          onClick={onBack}
          data-testid="breadcrumb-back"
          className={`p-1.5 rounded-lg mr-1 transition-colors ${
            isDark 
              ? 'hover:bg-white/10 text-slate-400 hover:text-white' 
              : 'hover:bg-slate-100 text-slate-500 hover:text-slate-800'
          }`}
          title="Go Back"
        >
          <ArrowLeft size={14} />
        </button>
      )}

      {/* Breadcrumb Items */}
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        const isFirst = index === 0;
        
        return (
          <React.Fragment key={item.path || index}>
            <button
              onClick={() => !isLast && onNavigate?.(item, index)}
              data-testid={`breadcrumb-${item.path}`}
              className={`flex items-center gap-1.5 px-2 py-1 rounded transition-colors ${
                isLast
                  ? isDark 
                    ? 'text-white font-semibold' 
                    : 'text-slate-900 font-semibold'
                  : isDark
                    ? 'text-slate-500 hover:text-blue-400 hover:bg-white/5 cursor-pointer'
                    : 'text-slate-500 hover:text-blue-600 hover:bg-slate-100 cursor-pointer'
              }`}
              disabled={isLast}
            >
              {isFirst && <Home size={12} />}
              <span className="truncate max-w-[120px]">{item.label}</span>
            </button>
            
            {!isLast && (
              <ChevronRight size={12} className={isDark ? 'text-slate-600' : 'text-slate-400'} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default Breadcrumb;
